var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',_vm._l((_vm.getErrors),function(error){return _c('b-alert',{key:error,attrs:{"color":"danger"}},[(_vm.$t(error))?_c('span',[_vm._v(_vm._s(_vm.$t(error)))]):_c('span',[_vm._v(_vm._s(error))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }